import { Plate, PlateContent, type PlateContentProps, type PlateEditor, useEditorContainerRef, useEditorRef } from '@udecode/plate/react';
import clsx from 'clsx';
import type { LegacyRef } from 'react';
import React from 'react';

export const InlineEditorReadonly: React.FC<{
    editor: PlateEditor;
    className?: string;
    containerClass?: string;
    placeholder?: string;
}> = ({
    editor,
    placeholder,
    className,
    containerClass
}) => {
    return (
        <Plate
            editor={editor}
            readOnly={true}
        >
            <div className={className}>
                <InlineEditorContainer className={clsx(
                    '[&_.slate-selection-area]:border [&_.slate-selection-area]:border-primary [&_.slate-selection-area]:bg-primary/10',
                    containerClass
                )}>
                    <InlineEditorInner
                        className='outline-none'
                        placeholder={placeholder}
                    />
                </InlineEditorContainer>
            </div>
        </Plate>
    );
};

export const InlineEditorContainer: React.FC<React.HTMLAttributes<HTMLDivElement>> = (props) => {
    const editor = useEditorRef();
    const containerRef = useEditorContainerRef();
    return (
        <div id={editor.uid} ref={containerRef as LegacyRef<HTMLDivElement>} {...props} />
    );
};

export const InlineEditorInner = React.forwardRef<HTMLDivElement, PlateContentProps>(
    ({ ...props }, ref) => {
        return (
            <PlateContent
                ref={ref}
                {...props}
            />
        );
    }
);
